import { createFileRoute } from "@tanstack/react-router";
import { LoggedOutPage } from "src/components/views/login/LoggedOutPage.tsx";

export const Route = createFileRoute("/loggedOut")({
	component: LoggedOutPage,
});
